import { render, staticRenderFns } from "./ca.vue?vue&type=template&id=867e2fea&scoped=true&"
import script from "./ca.vue?vue&type=script&lang=js&"
export * from "./ca.vue?vue&type=script&lang=js&"
import style0 from "./ca.vue?vue&type=style&index=0&id=867e2fea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867e2fea",
  null
  
)

export default component.exports